<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="searchbox">
      <div class="item">
        <span>结算账期</span>
        <el-date-picker
          v-model="settlement_time_range"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          value-format="yyyy-MM"
          style="margin-left: 6px; width: 240px"
          @change="handleSettlementTimeChange"
          clearable
        ></el-date-picker>
      </div>
      <div class="item">
        <span>医生姓名</span>
        <el-input
          placeholder="请输入"
          v-model="doctor_name"
          style="width: 140px; margin-left: 6px"
          clearable
          @input="search"
        ></el-input>
      </div>
      <div class="item">
        <span>手机号</span>
        <el-input
          placeholder="请输入"
          v-model="phone"
          style="width: 140px; margin-left: 6px"
          clearable
          @input="search"
        ></el-input>
        <el-button
          type="info"
          style="background-color: #eceff2; color: #747981; margin-left: 6px"
          @click="search"
          >查询</el-button
        >
        <span style="margin: 0 10px 0 15px" v-if="admin_id == 1"
          >是否测试医生</span
        >
        <el-radio-group v-model="is_test" @change="search" v-if="admin_id == 1">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="pricebox">
      <div class="price">
        <div class="priceitem">
          <div class="num" style="color: #333">{{ doctor_total }}</div>
          <div class="gray">医生人数</div>
        </div>
        <div class="priceitem">
          <div class="num">{{ sa_money_total }}</div>
          <div class="gray">税前金额总计</div>
        </div>
        <div class="priceitem">
          <div class="num">{{ taxation_money_total }}</div>
          <div class="gray">扣缴税额总计</div>
        </div>
        <div class="priceitem">
          <div class="num">{{ product_money_total }}</div>
          <div class="gray">项目推荐奖励总计</div>
        </div>
        <div class="priceitem">
          <div class="num">{{ goods_recommend_money_total }}</div>
          <div class="gray">商品推荐奖励总计</div>
        </div>
        <div class="priceitem">
          <div class="num">{{ pay_money_total }}</div>
          <div class="gray">税后总金额</div>
        </div>
      </div>
    </div>
    <div style="text-align: left; margin-bottom: 10px">
      <el-button
        type="primary"
        @click="settle"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('124') : false
        "
        >结算入账</el-button
      >
    </div>

    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>

        <el-table-column label="结算帐期" prop="period">
          <template slot-scope="scope">
            <div>{{ scope.row.period | dateFormat }}</div>
          </template>
        </el-table-column>

        <el-table-column label="医生信息" prop="hospital_name">
          <template slot-scope="scope">
            <div
              @click="showDocMsg(scope.row.doctor_id)"
              style="cursor: pointer"
            >
              {{ scope.row.doctor_name }}
            </div>
            <div>
              <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </div>
            <div>{{ scope.row.phone }}</div>
          </template>
        </el-table-column>

        <el-table-column label="科室" prop="department_name"></el-table-column>
        <el-table-column label="税前收入" prop="sa_money"></el-table-column>
        <el-table-column
          label="扣缴税额"
          prop="taxation_money"
        ></el-table-column>
        <el-table-column label="税后收入" prop="pay_money"></el-table-column>
        <el-table-column label="问诊费" prop="consult_money"></el-table-column>
        <el-table-column label="诊后管理费" prop="drug_price"></el-table-column>
        <el-table-column label="诊金" prop="consulting_gold"></el-table-column>
        <el-table-column
          label="项目推荐奖励"
          prop="product_money"
        ></el-table-column>
        <el-table-column label="平台奖励" prop="reward_money"></el-table-column>
        <el-table-column
          label="商品推荐奖励"
          prop="recommend_goods_money"
        ></el-table-column>
        <el-table-column
          label="终生分佣奖励"
          prop="forever_goods_money"
        ></el-table-column>
        <el-table-column label="心意金" prop="give_money"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="toDetail(scope.row.sa_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('123') : false
              "
              >查看明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="padding: 20px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import doctor_fee from "../../../api/doctor_fee";
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      totalNum: 0,
      doctor_name: "",
      phone: "",
      settlement_time_range: [],
      settlement_start_time: "",
      settlement_end_time: "",
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      selection: [],
      doctor_total: "",
      sa_money_total: "",
      taxation_money_total: "",
      pay_money_total: "",
      product_money_total: "",
      goods_recommend_money_total: "",
      is_test: 2,
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },

  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format("YYYY-MM");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        settlement_status: 1,
        doctor_name: this.doctor_name,
        phone: this.phone,
        settlement_start_time: this.settlement_start_time,
        settlement_end_time: this.settlement_end_time,
        is_test: this.is_test,
      };
      doctor_fee.getFeeSettlementList(data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list;
          this.doctor_total = res.data.doctor_total;
          this.sa_money_total = res.data.sa_money_total;
          this.taxation_money_total = res.data.taxation_money_total;
          this.pay_money_total = res.data.pay_money_total;
          this.product_money_total = res.data.product_money_total;
          this.goods_recommend_money_total =
            res.data.goods_recommend_money_total;
          this.totalNum = res.data.total;
        }
      });
    },

    //查看详情
    toDetail(sa_id) {
      this.$router.push({
        path: "preSettleDetail",
        query: {
          sa_id,
          settlement_status: 1,
        },
      });
    },
    //结算账期变更
    handleSettlementTimeChange(val) {
      if (val && val.length === 2) {
        this.settlement_start_time = val[0];
        this.settlement_end_time = val[1];
      } else {
        this.settlement_start_time = "";
        this.settlement_end_time = "";
      }
      this.search();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    //费用结算
    settle() {
      if (!this.selection.length) {
        this.$message.error("请先选择医生");
        return false;
      }
      let idarr = this.selection.map((item) => {
        return item.sa_id;
      });
      let sa_id = idarr.toString();
      this.$confirm("将该月费用结算，并入账到医生账户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading({
            text: "结算正在执行中，请不要关闭或者退出当前页面",
          });
          doctor_fee.settlement({ sa_id }).then((res) => {
            if (res.code == 0) {
              this.$message.success("结算成功");
              this.getList();
            }
            loading.close();
          });
        })
        .catch(() => {
          const loading = this.$loading();
          loading.close();
        });
    },
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  margin-top: 24px;
  .item {
    margin-right: 14px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      width: 200px;
      border-right: solid 1px #e1e3e9;
    }
    .priceitem:before {
      content: "";
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
</style>
